export default [
  {
    name: 'login',
    path: '/login',
    component: () => import('./login/Login'),
    meta: {
      requiredAuth: false
    }
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('./register/Register'),
    meta: {
      requiredAuth: false
    }
  },
  {
    name: 'createtenant',
    path: '/createtenant',
    props: (route) => ({ email: route.query.email, token: route.query.token }),
    component: () => import('./createTenant/CreateTenant'),
    meta: {
      requiredAuth: false
    }
  },
  {
    name: 'confirmFirstAccess',
    path: '/confirmFirstAccess',
    component: () => import('./confirm-firstaccess/ConfirmFirstAccess'),
    meta: {
      requiredAuth: false
    }
  },
  {
    name: 'changePassword',
    path: '/changePassword',
    component: () => import('./change-password/ChangePassword'),
    meta: {
      requiredAuth: false
    }
  },
  {
    path: '/atachment/document/pdf',
    name: 'atachmentdocumentpdf',
    component: () => import('@/app/shared/components/file-view/AtachmentDocumentPdf.vue'),
    meta: {
      requiredAuth: false

    }
  }
]
